<div class="Init">
  <header class="sticky-top">
    <div v-if="state_data.is_header_footer" class="header_title text-center py-2">おしゃべりリマインダー</div>
  </header>

  <!-- ローディング -->
  <loading v-model:active="loader.is_loading" :is-full-page="loader.is_full_page"></loading>
  <!-- メッセージ -->
  <b-alert v-model="message.is_alert" dismissible :variant="message.variant">{{ message.message }}</b-alert>

  <b-container class="px-0">
    <div class="text-center mt-4 mx-4">
      <div class="markdown-body" v-html="bind_data.markdowntext"></div>
    </div>

    <footer v-if="state_data.is_header_footer" class="sticky-bottom">
      <b-row>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="home()">「おしゃべりリマインダー」とは</b-button>
        </b-col>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="qa()">よくあるご質問</b-button>
        </b-col>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="terms_of_service()">利用規約</b-button>
        </b-col>
      </b-row>
      <br>
    </footer>
  </b-container>

</div>